import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useDate, useDateLimits, useScreen } from '../../../../../hooks'
import { DateTimePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import {
  QA_NAME_VIEWING_FORM_START,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { getIsViewingFormBookMode } from '../../RentalPortalViewingFormModal.utils'
import { getViewingFormFieldErrorProps } from '../../RentalPortalViewingFormModal.utils.validation'

function ViewingFormStartField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const { maxDate } = useDateLimits()

  const date = useDate()

  const { values } = useFormikContext()

  return (
    <FormikField
      Component={DateTimePicker}
      borderless={!isMobileScreenSize}
      dateProps={{
        placeholder: t('RentalPortal.ListingFormDatePlaceholderKey'),
      }}
      fieldComponentProps={{
        label: `${t('RentalPortal.ViewingFormStartLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getViewingFormFieldErrorProps}
      maxValue={maxDate}
      minValue={getIsViewingFormBookMode(values) ? undefined : date}
      name={VIEWING_FORM_FIELD_NAME.start}
      qaName={QA_NAME_VIEWING_FORM_START}
      timeProps={{
        placeholder: t('RentalPortal.ListingFormTimePlaceholderKey'),
      }}
    />
  )
}

export default ViewingFormStartField
